import { Box } from "theme-ui";

export default function ViewIcon(props) {
  return (
    <Box
      as="svg"
      width="28"
      height="24"
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 12L1.14251 11.4855L0.83381 12L1.14251 12.5145L2 12ZM26 12L26.8575 12.5145L27.1662 12L26.8575 11.4855L26 12ZM2.85749 12.5145C3.54645 11.3662 4.96267 9.58966 6.91636 8.10959C8.8667 6.63206 11.2844 5.5 14 5.5V3.5C10.7156 3.5 7.8833 4.86794 5.70864 6.51541C3.53733 8.16034 1.95355 10.1338 1.14251 11.4855L2.85749 12.5145ZM14 5.5C16.7156 5.5 19.1333 6.63206 21.0836 8.10959C23.0373 9.58966 24.4536 11.3662 25.1425 12.5145L26.8575 11.4855C26.0464 10.1338 24.4627 8.16034 22.2914 6.51541C20.1167 4.86794 17.2844 3.5 14 3.5V5.5ZM25.1425 11.4855C24.4536 12.6338 23.0373 14.4103 21.0836 15.8904C19.1333 17.3679 16.7156 18.5 14 18.5V20.5C17.2844 20.5 20.1167 19.1321 22.2914 17.4846C24.4627 15.8397 26.0464 13.8662 26.8575 12.5145L25.1425 11.4855ZM14 18.5C11.2844 18.5 8.8667 17.3679 6.91636 15.8904C4.96267 14.4103 3.54645 12.6338 2.85749 11.4855L1.14251 12.5145C1.95355 13.8662 3.53733 15.8397 5.70864 17.4846C7.8833 19.1321 10.7156 20.5 14 20.5V18.5Z"
        fill="black"
      />
      <circle cx="14" cy="12" r="4.5" stroke="black" strokeWidth="2" />
    </Box>
  );
}
